import api from '../../api/userAPI';
import { setErrorNotification } from '../snackbarNotification';

export const FETCH_BEGIN = 'appointmentSlot.list/FETCH_BEGIN';
export const FETCH_SUCCESS = 'appointmentSlot.list/FETCH_SUCCESS';
export const FETCH_FAILED = 'appointmentSlot.list/FETCH_FAILED';

const fetchBegin = () => ({ type: FETCH_BEGIN });
const fetchSuccess = data => ({ type: FETCH_SUCCESS, payload: data });
const fetchFailed = error => ({ type: FETCH_FAILED, payload: error });
export const fetchAppointmentSlotByDoctorAndDateAndAppointmentType = (
  doctorID,
  startDate,
  endDate,
  appointmentTypeName
) => async dispatch => {
  dispatch(fetchBegin());

  try {
    const res = await api(
      `retrieve-available-slot-for-frontend?doctor_id=${doctorID}&start_time=${startDate}&end_time=${endDate}&booking_type_name=${appointmentTypeName}`
    );

    dispatch(fetchSuccess(res.data.result));
  } catch (error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

export const fetchAppointmentSlotByDoctorAndDate = (
  doctorID,
  startDate,
  endDate
) => async dispatch => {
  dispatch(fetchBegin());

  try {
    const res = await api(
      `retrieve-available-slot-for-doctor?doctor_id=${doctorID}&start_time=${startDate}&end_time=${endDate}`
    );

    dispatch(fetchSuccess(res.data.result));
  } catch (error) {
    dispatch(fetchFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

const appointmentListReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_BEGIN:
      return { ...state, data: [], isLoading: true, error: null };
    case FETCH_SUCCESS:
      return { ...state, data: payload, isLoading: false };
    case FETCH_FAILED:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default appointmentListReducer;
